import RootRequest from 'GroomyRoot/assets/js/requests.js'
import Vue from 'vue'
import Store from '@/store/index'
import Constants from 'Constants'
import { EventBus } from 'EventBus'

export default class Request extends RootRequest {
    
    async after_request(caller, url, method, response, _) {
        return response
    }

    set_headers(bearer_token, tiers_id) {
        if(bearer_token != undefined) {
            Vue.axios.defaults.headers['Authorization'] = 'Bearer ' + bearer_token
            Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + bearer_token
        }

        Vue.axios.defaults.headers['Access-Control-Allow-Origin'] = Constants.BASE_API_URL
        Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = Constants.BASE_API_URL
        Vue.axios.defaults.headers.common['Accept-Language'] = Store.state.user.lang

        if(tiers_id != undefined) {
            Vue.axios.defaults.headers['tiersid'] = tiers_id
            Vue.axios.defaults.headers.common['tiersid'] = tiers_id
        }
    }

    reset_header() {
        Vue.axios.defaults.headers['Authorization'] = ''
        Vue.axios.defaults.headers['tiersid'] = ''
        Vue.axios.defaults.headers.common['tiersid'] = ''
    }

    catch_errors (err) {
        if (err.response) {
            if(err.response.status === 401) {
                // Token révoqué ou expiré (hors mauvais identifiants à la connexion).
                // On émet uniquement forceDelogUser, qui est debouncé (leading, 3 s)
                // dans App.vue : même si plusieurs requêtes simultanées reçoivent
                // un 401, un seul toast "session expirée" sera affiché.
                if (err.response.data && err.response.data.error !== 'Invalid credentials') {
                    EventBus.$emit('App::forceDelogUser')
                }
            }
            else if (err.response.status === 503) {
                EventBus.$emit('App::failureToast', 'error.TUN')
            } 
            else if (err.response.status == 406) {
                EventBus.$emit('App::failureToast', err.response.data.message)

                navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`).then(registration => {
                    registration.update();
                    EventBus.$emit('SW::updateFound')
                    EventBus.$on('SW::updated', () => {
                        window.location.reload()
                    })
                    setTimeout(() => {
                        window.location.reload()
                    }, 5000);
                })
            }
            else if (err.response.status == 403) {
                // si j'ai une 403 j'affiche un toast d'erreur et je redirige après 1s (le temps d'afficher le toast)
                EventBus.$emit('App::failureToast', err.response.data.message)
                setTimeout(() => {
                    window.location.replace("/");
                }, 1000)
            }
            else if (err.response.data) {
                const blacklist = ['CLDNHACA']

                if (err.response.data.type === 'ApiException' && blacklist.indexOf(err.response.data.code_retour) === -1) {
                    EventBus.$emit('App::failureToast', err.response.data.message)
                }
            } 
        }

        throw err
    }
}
